// HOWITWORKS - This mixin 

export default function (params) {
  
  return {

    directives: params.directives,
    computed: {
      
      // HOWITWORKS: This makes the entire {app} object accessible to every Vue component as just "this.app", rather than having to reference it from "AppData.app" each time.

      app () {
        return window.AppData.$data.app;
      }
      
    },
    
    methods: {
      
      // Used when a page (ie: TicketDetails) is being created to get any item that was already selected. Accepts a page, action, and params, then tries to load 1 item from the server if necessary.
      
      selectFromDetails(page, action, params) {
        
        if (!this.$route.query.details) return;
        
        // Check if already selected
        if (page.selected === this.$route.query.details) return;
        else {
          
          // Check list
          if (page.list && page.list.loaded) {
            for (var i = 0; i < page.list.items.length; ++i) {
              if (page.list.items[i] === this.$route.query.details) {
                Vue.set(page, 'selected', page.list.items[i]);
                return;
              }
            }
          }
          
          // Get from Server
          this.$store.dispatch(action, params)
          .then(data => {
            Vue.set(page, 'selected', data._id);
          })
          .catch(e => {
            this.routeRemoveQuery('details');
            Vue.set(page, 'selected', false);
            window.Toast.show('Item not found.', 'error');
            console.log('Error:', e);
          });
          
        }
      },
      
      // Copies existing queries and adds a new one 
      routeAddQuery(item, value) {
        value = value || true;
        var query = { ...this.$route.query };
        query[item] = value;
        this.$router.push({
          query: query
        });
      },
      
      // Same as above, but with an object
      routeAddQueries(obj) {
        var query = { ...obj, ...this.$route.query };
        this.$router.push({
          query: query
        });
      },
      
      // Removes only the query specified
      routeRemoveQuery(item) {
        var query = { ...this.$route.query };
        delete query[item];
        this.$router.replace({
          query: query
        });
      },
      
      // Same as above, but an array
      routeRemoveQueries(leArray) {
        var query = { ...this.$route.query };
        
        for (var i = 0; i < leArray.length; ++i) {
          delete query[leArray[i]];
        }
        
        this.$router.replace({
          query: query
        });
      }
      
    },
    store: params.store
  }
}


// WEBPACK FOOTER //
// ./src/globalMixin.js